import { useMutation } from "react-query";

import { CombinationRulesPrecheckResponse } from "~/entity/CombinationRules/model/schema";

import { useCombinationRules } from "./useCombinationRules";

interface MutateOptions {
  onSuccess?: (data: CombinationRulesPrecheckResponse) => void;
  onError?: (error: unknown) => void;
}

interface DataIProps {
  options?: MutateOptions;
}

export const usePrecheckAllCombinationRules = () => {
  const { rulesPrecheckAll } = useCombinationRules();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const response = await rulesPrecheckAll();
      return { data: response.data, options: props.options };
    },
    onSuccess: ({ data, options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const precheckAll = (options?: MutateOptions) => {
    mutation.mutate({ options });
  };

  return { precheckAll, isLoading: mutation.isLoading };
};
